import {
    getTemplateByIdAPI
} from "../sevices/templateService";

export const getTemplateById = (id) => async (dispatch) => {
    await dispatch(getTemplateByIdAPI(id));
};
